import { Loader, LoaderOptions } from 'google-maps';

class GoogleMapsService {

    async changeMap(mapId, lat, lng, markerImage) {
        const coordinates = { lat: lat, lng: lng };

        let google = {};

        if (!window.google) {
            const loader = new Loader('AIzaSyAJxw4gH880IdqkCB0mfT5GrU0DHd-6SKc', {});
            google = await loader.load();
        } else {
            google = window.google;
        }

        const map = new google.maps.Map(document.getElementById(mapId), {
            center: coordinates,
            zoom: 16,
            disableDefaultUI: true,
        });

        var icon = {
            url: markerImage, // url
            scaledSize: new google.maps.Size(40, 33), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(0, 0) // anchor
        };

        const marker = new google.maps.Marker({
            position: coordinates,
            map: map,
            icon: icon
        });
    }
}

export { GoogleMapsService };